import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import HeroBanner from "../Hero/HeroBanner";
import HeroImg from "../../../assets/medical/contactus/kapcsolat_banner_nagy.png";
import "./contactUs.css";
import crossImg from "../../../assets/medical/contactus/pharmacy.png";
import googleTerkep from "../../../assets/chemical/contactus/kemiai_analitika_google_map.png";
import terkepVonallal from "../../../assets/medical/contactus/orvosdiagnosztika_map-utvonal_min.png";

const ContactUs = () => {
  return (
    <>
      <Helmet>
        <title>
          Kapcsolat | Bálint Analitika Laboratórium | Budapest XI. kerület
        </title>
        <meta
          name="description"
          content="Vegye fel a kapcsolatot a Bálint Analitika laboratóriummal! Látogasson el hozzánk a Budapest XI. kerület, Kondorfa utca 6. szám alatti központunkba vagy hívjon minket telefonon: +36 20 254 2591."
        />
        <meta
          name="keywords"
          content="Bálint Analitika kapcsolat, orvosi laboratórium Budapest, vérvétel XI. kerület, laborvizsgálat elérhetőség"
        />
        <link
          rel="canonical"
          href="https://balintanalitika.hu/orvosdiagnosztika/kapcsolat"
        />

        {/* Schema.org structured data for Local Business */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalLaboratory",
            name: "Bálint Analitika Laboratórium",
            url: "https://balintanalitika.hu",
            logo: "https://balintanalitika.hu/assets/medical/logo/logo.png",
            image:
              "https://balintanalitika.hu/assets/medical/contactus/kapcsolat_banner_nagy.png",
            telephone: "+36-20-254-2591",
            email: "orvosdiagnosztika@balintanalitika.hu",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Kondorfa utca 6.",
              addressLocality: "Budapest",
              postalCode: "1116",
              addressRegion: "XI. kerület",
              addressCountry: "HU",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: "47.4631",
              longitude: "19.0292",
            },
            openingHoursSpecification: [
              {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                ],
                opens: "07:00",
                closes: "16:00",
              },
            ],
          })}
        </script>
      </Helmet>
      <HeroBanner
        srcBig={HeroImg}
        srcSmall={HeroImg}
        alt="Bálint Analitika laboratórium kapcsolat"
      />
      <main className="contact-us">
        <h1 className="visually-hidden">
          Kapcsolat a Bálint Analitika laboratóriummal
        </h1>

        <div className="contact-us-container container">
          <section className="contact-info-section">
            <div className="contact-box">
              <span aria-hidden="true">
                <img
                  src={crossImg}
                  className="contact-box-icon"
                  alt="Orvosi kereszt ikon"
                  width="64"
                  height="64"
                />
              </span>
              <h2 className="contact-box-title">
                Ügyfélszolgálat - Orvosdiagnosztika
              </h2>
              <p className="contact-box-text">
                Vizsgálatainkról érdeklődne, esetleg időpontot szeretne
                foglalni? Keressen minket, hétfőtől péntekig 7:00-16:00 között
                állunk rendelkezésére a Budapest XI. kerületében található
                laboratóriumunkban.
              </p>
              <a
                href="tel:+36202542591"
                className="contact-box-link"
                aria-label="Hívás a mobil telefonszámon: +36 20 254 2591"
              >
                +36 20 254 2591
              </a>
              <a
                href="tel:+3612053044"
                className="contact-box-link"
                aria-label="Hívás a vezetékes telefonszámon: +36 1 205 3044"
              >
                +36 1 205 3044
              </a>
              <a
                href="mailto:orvosdiagnosztika@balintanalitika.hu"
                className="contact-box-link"
                aria-label="Email küldése az orvosdiagnosztika@balintanalitika.hu címre"
              >
                orvosdiagnosztika@balintanalitika.hu
              </a>
            </div>
          </section>
        </div>
        <section className="contact-us-gmap-section">
          <h2 className="contact-us-gmap-section-title">
            Helyileg itt vagyunk megtalálhatók
          </h2>
          <div className="contact-us-gmap-container">
            <div className="contact-us-gmap-wrapper">
              <Link
                to="https://maps.app.goo.gl/EdUHL8ac4MbjmhR86"
                target="_blank"
              >
                <img
                  src={googleTerkep}
                  className="d-block h-100 w-100 contact-us-gmap-img"
                  alt="telephely térkép linkkel"
                  rel="preload"
                />
              </Link>

              <div className="contact-us-gmap-content">
                <h3 className="contact-us-gmap-content-title">
                  Központ <br /> Mintavételi helyszín
                </h3>
                <p className="contact-us-gmap-content-address">
                  1116 Budapest, <br />
                  Kondorfa u. 6.
                </p>
                <h5 className="contact-us-gmap-content-open-hours">
                  Nyitvatartás
                </h5>
                <p className="contact-us-gmap-open-text">
                  Hétfőtől péntekig 7:00-16:00 között állunk rendelkezésére.
                </p>
                <h5 className="contact-us-gmap-content-contact">Elérhetőség</h5>
                <div className="contact-us-gmap-content-contact-phone">
                  +36 20 254 2591 <br />
                  +36 1 205 3044 orvosdiagnosztika@balintanalitika.hu
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="contact-us-get-there-section">
          <h2 className="contact-us-get-there-section-title">
            Így juthat el hozzánk
          </h2>
          <p className="contact-us-get-there-text">
            <strong>Autóval</strong>: kérjük használja a{" "}
            <a href="https://goo.gl/maps/c1JrYywbQY2oVfUc8">térképet</a>, de a
            megközelítés csak a Kondorfa utca felől lehetséges!
          </p>
          <p className="contact-us-get-there-text">
            <strong>Tömegközlekedéssel</strong>: 17, 41, 47, 56, 56A villamos
            Albertfalva kitérő megállójánál kell leszállni, majd 5 perc séta a
            Temesvár utcán keresztül.
          </p>
          <p className="contact-us-get-there-text">
            <strong>Parkolás</strong>: ügyfeleink részére külön fenntartott
            parkolóhelyekkel rendelkezünk a belső udvarban.
          </p>
          <p className="contact-us-get-there-text">
            <strong>Telephelyi térképünk</strong>:
          </p>
          <img
            src={terkepVonallal}
            className="contact-us-get-there-img"
            alt="térkép a telephelyről"
          />
        </section>
      </main>
    </>
  );
};

export default ContactUs;
